import StatusPill from 'components/StatusPill';
import { BatchFileType, useHistoryBatch } from 'contexts/HistoryBatch';
import { StatusFile } from 'models/statusFile';
import React, { FC, useRef } from 'react';
import { formatDate } from 'utils/formatDate';
import { ErrorMobile } from './ErrorMobile';
import { PartialProcessedMobile } from './PartialProcessedMobile';
import { ProcessedMobile } from './ProcessedMobile';
import { ProcessingMobile } from './ProcessingMobile';

interface StatusMobileProps {
  file: BatchFileType;
  index: number;
}

export const HistoryBatchStatusMobile: FC<StatusMobileProps> = ({ file, index }) => {
  const { selectedFile, setFile, setFileState, fileDetails } = useHistoryBatch();

  const ref = useRef<null | HTMLDivElement>(null);

  const isSelected = selectedFile?.id === file.id;

  const statusFile = file.status;

  const isEmptyCpf = fileDetails?.every((item) => item.cpf.trim() === '');

  const isPartial = statusFile === StatusFile.PARTIAL_PROCESSED;

  const isProcessed = statusFile === StatusFile.PROCESSED;

  const isProcessing = statusFile === StatusFile.PROCESSING;

  const isError = statusFile === StatusFile.ERROR;

  const isDeactivate = selectedFile?.filename?.includes('DS');

  const handleSelectStatus = () => {
    if (!ref.current) return;

    isSelected ? setFileState(undefined) : setFile(file);

    setTimeout(() => {
      ref.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }, 400);
  };

  return (
    <div ref={ref}>
      <div
        className={`${isSelected ? 'mobile-row-selected' : 'mobile-row'}${
          file.status === StatusFile.PARTIAL_PROCESSED || file.status === StatusFile.ERROR ? '-error' : ''
        }`}
        data-testid={`test-row-${index}`}
        onClick={handleSelectStatus}
      >
        <div className="pill-row">
          <StatusPill status={file.status} selected={isSelected} />
          <span className="chevron-down" />
        </div>
        <div className="date-row">
          <span>Data: </span>
          <span>{formatDate(file.created)}</span>
        </div>
        <div className="name-row">
          <span>Nome: </span>
          <span>{file.filename}</span>
        </div>
      </div>
      <div className={isSelected ? 'wrapper is-open' : 'wrapper'}>
        <div className={isSelected ? 'inner-selected' : 'inner'}>
          {isProcessed && <ProcessedMobile />}
          {isPartial && <PartialProcessedMobile isDeactivate={isDeactivate} />}
          {isProcessing && <ProcessingMobile />}
          {isError &&
            (isEmptyCpf ? (
              <ErrorMobile isDeactivate={isDeactivate} />
            ) : (
              <PartialProcessedMobile isDeactivate={isDeactivate} />
            ))}
        </div>
      </div>
    </div>
  );
};
